import { useEffect, useState, useCallback } from "react";
import ArchingService from "../../services/ArchingService";
import CashRegisterService from "../../services/cashRegisterService";
import { utils } from "./utils";

const mapTotals = (totals) =>
    totals.reduce((total, curr) => ({
        ...total,
        [curr.cashType === "Cash" ? curr.cashType + curr.currency : curr.cashType]: {
            ingress: curr.ingressTotal,
            egress: curr.egressTotal,
            lastClosureAmount: curr.lastClosureAmount,
            total: curr.total,
            price: curr.price 
        },
        ingressTotal: total.ingressTotal + curr.ingressTotal,
        egressTotal: total.egressTotal + curr.egressTotal,
        lastClosureAmountTotal: total.lastClosureAmount + curr.lastClosureAmount,
        fullTotal: total.fullTotal + curr.total

    }), {
        ingressTotal: 0,
        egressTotal: 0,
        lastClosureAmount:0,
        fullTotal: 0
    })

const useTotals = ( cashRegisterId ) => {
    const [totals, setTotals] = useState();
    const [loading, setLoading] = useState(false);

    const getTotals = useCallback((cashRegisterId) => {
        setLoading(true);
        CashRegisterService
            .GetTotals(cashRegisterId)
            .then(res => setTotals(mapTotals(res)))
            .finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        if (cashRegisterId)
            getTotals(cashRegisterId);
    }, [cashRegisterId, getTotals])

    const createArching = async (archingDetails, userEmail) => {
        const auxDetails = utils.GetDetails(archingDetails);
        const res = await ArchingService.CreateArching({
            cashRegisterId,
            userEmail,
            details: auxDetails
        }).catch(() => false)
        return res;
    }

    return {
        totals,
        loading,
        createArching,
        getTotals,
    }
}

export default useTotals;